export default __webpack_public_path__ + "static/media/iitc.1f97e9d3.png";